import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CONFIG from "../src/config";
import axios from "axios";
import { useLocation } from "react-router-dom";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";

const BoardofDirectors = () => {
  const location = useLocation();
  const baseUrl = "https://ktig.info";
  const [bioData, setBioData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const meta = metaConfig.directorsboard;

  useEffect(() => {
    const fetchBioData = async () => {
      try {
        const response = await axios.get(`${CONFIG.BASE_URL}/biodata/get/all`);
        setBioData(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching bio data:", err);
        setError("Failed to load board members. Please try again later.");
        setLoading(false);
      }
    };

    fetchBioData();
  }, []);

  if (loading) {
    return (
      <div className="container-fluid innercontain team boardmbers_inn overflow-hidden py-5">
        <div className="container text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid innercontain team boardmbers_inn overflow-hidden py-5">
        <div className="container text-center py-5 text-white">{error}</div>
      </div>
    );
  }

  return (
    <div>
      <SEO {...meta} />
      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>

      <div className="container-fluid boardmember_bread bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Community and Family Ties
          </h4>
        </div>
      </div>

      <div
        className="modal fade"
        id="searchModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                className="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                className="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div className="modal-body align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  className="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  className="input-group-text btn border p-3"
                >
                  <i className="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid innercontain team boardmbers_inn overflow-hidden py-5">
        <div className="container">
          <div
            className="text-center mx-auto pb-3 wow fadeInUp"
            data-wow-delay="0.2s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-3 text-white text-capitalize mb-3">
              KTIG BOARD OF MEMBERS
            </h1>
          </div>

          <div className="row mt-3 mp-0 pb-5 g-4">
            {bioData.length > 0 ? (
              bioData.map((item) => (
                <div
                  key={item._id}
                  className="col-md-3 boardlist_inner mt-0 col-lg-3"
                >
                  <div
                    className="col-md-12 mt-0 col-lg-12 boardlist p-0 wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="team-item p-3">
                      <Link
                        to="/board-of-directories-details"
                        state={{ bioData: item }}
                        className="text-decoration-none"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <div className="team-inner rounded">
                          <div className="team-img">
                            <img
                              src={item.imagePath || "/default-profile.png"}
                              className="img-fluid rounded-top w-100"
                              alt={item.memberName}
                              onError={(e) => {
                                e.target.src = "/default-profile.png";
                              }}
                            />
                          </div>
                          <div className="teamcontent rounded-bottom text-center py-4">
                            <h6 className="mb-3">{item.memberName}</h6>
                            <p className="mb-0">{item.designation}</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center text-white">
                No board members found.
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />

      <button
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
        onClick={() => window.scrollTo(0, 0)}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
};

export default BoardofDirectors;
